/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConteneurDto } from '../models/conteneur-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DemandeTransportDto } from '../models/demande-transport-dto';
import { EidDataRecordDto } from '../models/eid-data-record-dto';
import { LoadResultDto } from '../models/load-result-dto';
import { MaterielParcDto } from '../models/materiel-parc-dto';
import { ParcActifDto } from '../models/parc-actif-dto';
import { ParcDto } from '../models/parc-dto';
import { ParcDetailsDto } from '../models/parc-details-dto';
import { ParcLimitropheDto } from '../models/parc-limitrophe-dto';
import { ParcProcheInfo } from '../models/parc-proche-info';
import { TelephoneDto } from '../models/telephone-dto';


/**
 * Fonctions de gestion des recyparcs
 */
@Injectable({
  providedIn: 'root',
})
export class ParcsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation parcGetList
   */
  static readonly ParcGetListPath = '/api/parcs/list';

  /**
   * Renvoie la liste des recyparcs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des recyparcs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetList(params?: {
  }): Observable<Array<ParcDto>> {

    return this.parcGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcDto>>) => r.body as Array<ParcDto>)
    );
  }

  /**
   * Path part for operation parcGetListActifs
   */
  static readonly ParcGetListActifsPath = '/api/parcs/list-actifs';

  /**
   * Renvoie la liste des recyparcs actifs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ParcActifDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcActifDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des recyparcs actifs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetListActifs(params?: {
  }): Observable<Array<ParcActifDto>> {

    return this.parcGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcActifDto>>) => r.body as Array<ParcActifDto>)
    );
  }

  /**
   * Path part for operation parcLoadList
   */
  static readonly ParcLoadListPath = '/api/parcs/load-list';

  /**
   * Renvoie la liste des recyparcs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResultDto>;
      })
    );
  }

  /**
   * Renvoie la liste des recyparcs (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResultDto> {

    return this.parcLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResultDto>) => r.body as LoadResultDto)
    );
  }

  /**
   * Path part for operation parcGet
   */
  static readonly ParcGetPath = '/api/parcs/{id}';

  /**
   * Renvoie le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGet$Response(params: {

    /**
     * Identifiant du recyparc
     */
    id: number;
  }): Observable<StrictHttpResponse<ParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcDto>;
      })
    );
  }

  /**
   * Renvoie le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGet(params: {

    /**
     * Identifiant du recyparc
     */
    id: number;
  }): Observable<ParcDto> {

    return this.parcGet$Response(params).pipe(
      map((r: StrictHttpResponse<ParcDto>) => r.body as ParcDto)
    );
  }

  /**
   * Path part for operation parcPut
   */
  static readonly ParcPutPath = '/api/parcs/{id}';

  /**
   * Met à jour le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPut$Response(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Recyparc
     */
    body: ParcDto
  }): Observable<StrictHttpResponse<ParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcDto>;
      })
    );
  }

  /**
   * Met à jour le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPut(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Recyparc
     */
    body: ParcDto
  }): Observable<ParcDto> {

    return this.parcPut$Response(params).pipe(
      map((r: StrictHttpResponse<ParcDto>) => r.body as ParcDto)
    );
  }

  /**
   * Path part for operation parcDelete
   */
  static readonly ParcDeletePath = '/api/parcs/{id}';

  /**
   * Supprime le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcDelete$Response(params: {

    /**
     * Identifiant du recyparc à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcDelete(params: {

    /**
     * Identifiant du recyparc à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.parcDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation parcGetDetail
   */
  static readonly ParcGetDetailPath = '/api/parcs/detail/{id}';

  /**
   * Renvoie le détail du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetDetail$Response(params: {

    /**
     * Identifiant du recyparc
     */
    id: number;
  }): Observable<StrictHttpResponse<ParcDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetDetailPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcDetailsDto>;
      })
    );
  }

  /**
   * Renvoie le détail du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetDetail(params: {

    /**
     * Identifiant du recyparc
     */
    id: number;
  }): Observable<ParcDetailsDto> {

    return this.parcGetDetail$Response(params).pipe(
      map((r: StrictHttpResponse<ParcDetailsDto>) => r.body as ParcDetailsDto)
    );
  }

  /**
   * Path part for operation parcPost
   */
  static readonly ParcPostPath = '/api/parcs';

  /**
   * Crée le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPost$Response(params: {

    /**
     * Recyparc
     */
    body: ParcDto
  }): Observable<StrictHttpResponse<ParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcDto>;
      })
    );
  }

  /**
   * Crée le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPost(params: {

    /**
     * Recyparc
     */
    body: ParcDto
  }): Observable<ParcDto> {

    return this.parcPost$Response(params).pipe(
      map((r: StrictHttpResponse<ParcDto>) => r.body as ParcDto)
    );
  }

  /**
   * Path part for operation parcPutTelephones
   */
  static readonly ParcPutTelephonesPath = '/api/parcs/{id}/telephones';

  /**
   * Met à jour les téléphones du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcPutTelephones()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPutTelephones$Response(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Téléphones à mettre à jour
     */
    body: Array<TelephoneDto>
  }): Observable<StrictHttpResponse<Array<TelephoneDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcPutTelephonesPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TelephoneDto>>;
      })
    );
  }

  /**
   * Met à jour les téléphones du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcPutTelephones$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPutTelephones(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Téléphones à mettre à jour
     */
    body: Array<TelephoneDto>
  }): Observable<Array<TelephoneDto>> {

    return this.parcPutTelephones$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TelephoneDto>>) => r.body as Array<TelephoneDto>)
    );
  }

  /**
   * Path part for operation parcPutMateriels
   */
  static readonly ParcPutMaterielsPath = '/api/parcs/{id}/materiels';

  /**
   * Met à jour les matériels du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcPutMateriels()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPutMateriels$Response(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Matériels à mettre à jour
     */
    body: Array<MaterielParcDto>
  }): Observable<StrictHttpResponse<Array<MaterielParcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcPutMaterielsPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MaterielParcDto>>;
      })
    );
  }

  /**
   * Met à jour les matériels du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcPutMateriels$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPutMateriels(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Matériels à mettre à jour
     */
    body: Array<MaterielParcDto>
  }): Observable<Array<MaterielParcDto>> {

    return this.parcPutMateriels$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MaterielParcDto>>) => r.body as Array<MaterielParcDto>)
    );
  }

  /**
   * Path part for operation parcPutParcsLimitrophes
   */
  static readonly ParcPutParcsLimitrophesPath = '/api/parcs/{id}/parcs-limitrophes';

  /**
   * Met à jour les recyparcs limitrophes du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcPutParcsLimitrophes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPutParcsLimitrophes$Response(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Recyparcs limitrophes à mettre à jour
     */
    body: Array<ParcLimitropheDto>
  }): Observable<StrictHttpResponse<Array<ParcLimitropheDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcPutParcsLimitrophesPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcLimitropheDto>>;
      })
    );
  }

  /**
   * Met à jour les recyparcs limitrophes du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcPutParcsLimitrophes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPutParcsLimitrophes(params: {

    /**
     * Identifiant du recyparc à mettre à jour
     */
    id: number;

    /**
     * Recyparcs limitrophes à mettre à jour
     */
    body: Array<ParcLimitropheDto>
  }): Observable<Array<ParcLimitropheDto>> {

    return this.parcPutParcsLimitrophes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcLimitropheDto>>) => r.body as Array<ParcLimitropheDto>)
    );
  }

  /**
   * Path part for operation parcDesactivate
   */
  static readonly ParcDesactivatePath = '/api/parcs/{id}/desactivate';

  /**
   * Désactive le recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcDesactivate$Response(params: {

    /**
     * Identifiant du recyparc à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ParcDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcDesactivate(params: {

    /**
     * Identifiant du recyparc à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: ParcDto
  }): Observable<number> {

    return this.parcDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation parcGetByReference
   */
  static readonly ParcGetByReferencePath = '/api/parcs/reference/{reference}';

  /**
   * Renvoie le recyparc recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<ParcDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ParcDto>;
      })
    );
  }

  /**
   * Renvoie le recyparc recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<ParcDto> {

    return this.parcGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<ParcDto>) => r.body as ParcDto)
    );
  }

  /**
   * Path part for operation parcGetTodayVisitesCount
   */
  static readonly ParcGetTodayVisitesCountPath = '/api/parcs/visites-du-jour/{parcId}';

  /**
   * Renvoie le nombre de visites du jour pour le parc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetTodayVisitesCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetTodayVisitesCount$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetTodayVisitesCountPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Renvoie le nombre de visites du jour pour le parc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetTodayVisitesCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetTodayVisitesCount(params: {

    /**
     * Identifiant du parc
     */
    parcId: number;
  }): Observable<number> {

    return this.parcGetTodayVisitesCount$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation parcEstFerme
   */
  static readonly ParcEstFermePath = '/api/parcs/est-ferme/{parcId}';

  /**
   * Renvoie si le parc spécifié est fermé à la date spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcEstFerme()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcEstFerme$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId: number;

    /**
     * Date pour laquelle on veut savoir si le parc est fermé
     */
    date?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcEstFermePath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
      rb.query('date', params.date, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Renvoie si le parc spécifié est fermé à la date spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcEstFerme$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcEstFerme(params: {

    /**
     * Identifiant du parc
     */
    parcId: number;

    /**
     * Date pour laquelle on veut savoir si le parc est fermé
     */
    date?: string;
  }): Observable<number> {

    return this.parcEstFerme$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation parcPostEidRead
   */
  static readonly ParcPostEidReadPath = '/api/parcs/{id}/eid-read';

  /**
   * Réception des informations lues par un lecteur EID sur le parc {id}.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcPostEidRead()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPostEidRead$Response(params: {

    /**
     * Identifiant du recyparc
     */
    id: number;

    /**
     * Données
     */
    body: EidDataRecordDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcPostEidReadPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Réception des informations lues par un lecteur EID sur le parc {id}.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcPostEidRead$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcPostEidRead(params: {

    /**
     * Identifiant du recyparc
     */
    id: number;

    /**
     * Données
     */
    body: EidDataRecordDto
  }): Observable<void> {

    return this.parcPostEidRead$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation parcGetConteneursMobiles
   */
  static readonly ParcGetConteneursMobilesPath = '/api/parcs/conteneurs-mobiles/{parcId}';

  /**
   * Renvoie la liste des conteneurs mobiles du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetConteneursMobiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetConteneursMobiles$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<ConteneurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetConteneursMobilesPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConteneurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs mobiles du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetConteneursMobiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetConteneursMobiles(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<ConteneurDto>> {

    return this.parcGetConteneursMobiles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ConteneurDto>>) => r.body as Array<ConteneurDto>)
    );
  }

  /**
   * Path part for operation parcGetConteneurs
   */
  static readonly ParcGetConteneursPath = '/api/parcs/conteneurs/{parcId}';

  /**
   * Renvoie la liste des conteneurs du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetConteneurs()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetConteneurs$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<ConteneurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetConteneursPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ConteneurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des conteneurs du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetConteneurs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetConteneurs(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<ConteneurDto>> {

    return this.parcGetConteneurs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ConteneurDto>>) => r.body as Array<ConteneurDto>)
    );
  }

  /**
   * Path part for operation parcGetDemandesTransport
   */
  static readonly ParcGetDemandesTransportPath = '/api/parcs/demandes-transport/{parcId}';

  /**
   * Renvoie la liste des demandes de transport du recyparc spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetDemandesTransport()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetDemandesTransport$Response(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<StrictHttpResponse<Array<DemandeTransportDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetDemandesTransportPath, 'get');
    if (params) {
      rb.path('parcId', params.parcId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DemandeTransportDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes de transport du recyparc spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetDemandesTransport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetDemandesTransport(params: {

    /**
     * Identifiant du recyparc
     */
    parcId: number;
  }): Observable<Array<DemandeTransportDto>> {

    return this.parcGetDemandesTransport$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DemandeTransportDto>>) => r.body as Array<DemandeTransportDto>)
    );
  }

  /**
   * Path part for operation parcGetParcsProches
   */
  static readonly ParcGetParcsProchesPath = '/api/parcs/parcs-proches/{typeDechetId}/{codePostalId}';

  /**
   * Retourne les recyparcs proches d'un code postal qui prennent en charge le type de déchets demandé.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcGetParcsProches()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetParcsProches$Response(params: {

    /**
     * Type de déchets
     */
    typeDechetId: number;

    /**
     * Code postal
     */
    codePostalId: number;
  }): Observable<StrictHttpResponse<Array<ParcProcheInfo>>> {

    const rb = new RequestBuilder(this.rootUrl, ParcsService.ParcGetParcsProchesPath, 'post');
    if (params) {
      rb.path('typeDechetId', params.typeDechetId, {});
      rb.path('codePostalId', params.codePostalId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParcProcheInfo>>;
      })
    );
  }

  /**
   * Retourne les recyparcs proches d'un code postal qui prennent en charge le type de déchets demandé.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcGetParcsProches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  parcGetParcsProches(params: {

    /**
     * Type de déchets
     */
    typeDechetId: number;

    /**
     * Code postal
     */
    codePostalId: number;
  }): Observable<Array<ParcProcheInfo>> {

    return this.parcGetParcsProches$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParcProcheInfo>>) => r.body as Array<ParcProcheInfo>)
    );
  }

}
